import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { CanvasOutlinePanelProps } from './CanvasOutlinePanel';

export type RequirementsCanvasOutlineContextValue = {
    outlinePanel: CanvasOutlinePanelProps | null;
    setOutlinePanel: (props: CanvasOutlinePanelProps | null) => void;
};

const RequirementsCanvasOutlineContext = createContext<RequirementsCanvasOutlineContextValue | null>(null);

export const RequirementsCanvasOutlineProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [outlinePanel, setOutlinePanelState] = useState<CanvasOutlinePanelProps | null>(null);

    const setOutlinePanel = useCallback((props: CanvasOutlinePanelProps | null) => {
        setOutlinePanelState(props);
    }, []);

    const value = useMemo(
        () => ({ outlinePanel, setOutlinePanel }),
        [outlinePanel, setOutlinePanel]
    );

    return (
        <RequirementsCanvasOutlineContext.Provider value={value}>
            {children}
        </RequirementsCanvasOutlineContext.Provider>
    );
};

export function useRequirementsCanvasOutline(): RequirementsCanvasOutlineContextValue {
    const ctx = useContext(RequirementsCanvasOutlineContext);
    if (!ctx) {
        throw new Error('useRequirementsCanvasOutline must be used within RequirementsCanvasOutlineProvider');
    }
    return ctx;
}

/** Sidebar may render outside the provider in tests — returns null-safe no-op. */
export function useRequirementsCanvasOutlineOptional(): RequirementsCanvasOutlineContextValue | null {
    return useContext(RequirementsCanvasOutlineContext);
}
